module.exports = __webpack_public_path__ + "img/p72.acc54d78.jpg";